<template>
<div class="option-box">
     <h4>{{roleData.roleName}}权限配置</h4>
     <el-button @click = "subFun" type="primary">确认修改</el-button>
</div>
<!-- list是组件需要接收的权限列表 -->
  <treeItem :list="authorityList"/>
  <!-- <el-tree
    ref="treeDom"
    :data="authorityList"
    show-checkbox
    node-key="roleId"
    check-strictly
    default-expand-all
    :default-checked-keys="roleData.authority"
    :props="defaultProps"
  >
  </el-tree> -->
</template>
<script>
import { onMounted, reactive, toRefs ,ref} from "vue";
import { useRoute } from "vue-router";
import { getRoleAuthority, getAuthority } from "../http/api";
import treeItem from '../components/treeItem'
import roleIdData from '../sateJs/roleId.js'
export default {
  components:{
    treeItem,  
  },
    setup() {
    const route = useRoute();
    let data = reactive({
      authorityList: [],
      defaultProps:{
          label:'name',
          children:'roleList'
      },
      roleData:{}
    });
    let treeDom = ref(null)
    onMounted(() => {
      //当前需要修改的角色的权限
      getRoleAuthority().then((res) => {
        data.roleData = res.filter(v=>v.roleId==route.query.id)[0]
        console.log(data.roleData)
        //给全局状态roleids数据赋值
        roleIdData.ids = data.roleData.authority
      });
      //  获取项目所有的权限
      getAuthority().then((res) => {
        data.authorityList = res;
      });
    });

    const subFun=()=>{
        console.log(roleIdData.ids)
      //  console.log(treeDom.value.getCheckedKeys())
    }
    return {
      ...toRefs(data),
      treeDom,
      subFun
    };
  },
};
</script>
<style lang="scss" scoped>
.option-box {
  margin: 10px;
}
</style>